import React, { useCallback, useEffect, useRef, useState } from 'react'
import styles from './style.module.css';
import { useDispatch, useSelector } from 'react-redux';
import { ARROW_LEFT, CLOSE, DRIVER, FORWARD, Ic_danger, ROUTE_OPTIMIZE, Routes_deactive, SEARCH_NOT_FOUND, box_gray, flag_gray, start_time } from '../../../assets';
import Button from '../../../design-system/lib/Button';
import Typography from '../../../design-system/lib/Typography';
import Tag from '../../../design-system/lib/Tag';
import clsx from 'clsx';
import { Link } from 'react-router-dom';
import { ResetNewOrder, Table_setSelectedBulkEditStatusSummary, clearAll_Route_ActiveFilter, handleEditRouteFilter_Name } from '../../../Redux/actions/actionNames';
import jalali from "jalali-moment";
import { checkTimestamp, get_lang } from '../../../helper/UserData/userdate';
import RouteListNavbar from './route-list-navbar';
import { RouteApi } from '../../../service/API/route';
import IconProvider from '../../../design-system/lib/IconProvider';
import ProgressIndicator from '../../../design-system/lib/ProgressIndicator';
import { GetRouteRangeFilter } from '../../../hooks/GetRouteRangeFilter';
import DateFilter from '../../../design-system/lib/DateFilter';
import { GetRouteCheckboxFilter } from '../../../hooks/GetRouteCheckboxFilter';
import CheckBoxFilter from '../../../design-system/lib/CheckBoxFilter';
import InputSerachFilter from '../../../design-system/lib/InputSerachFilter';
import DriverListItem from '../../shared/DriverListItem';
import { DispatcherApi } from '../../../service/API/dispatcher';
import useMeasure from 'react-use-measure';
import momentJalaali from "moment-jalaali";

import _, { isNumber, isObject, debounce } from 'lodash';
import TableAddRoute from '../selectedOrders/components/addRoute';
import { defRoute, initRoute } from '../../../Redux/reducers/route';
import { useQuery } from '../../../hooks/useQuery';
import { DriverApi } from '../../../service/API/driver';
import EditStatusRoute from './components/editStatus';
import { store } from '../../../Redux/store';
import { RoutesListES } from "@onro/onboarding";
import { useTranslation } from 'react-i18next';
import { LearnMore } from '../../learnMore';
import { ServicesVehicletypeAction } from '../../../Redux/actions/actions';
import history from '../../../service/history';
import ProgressBar from '../../../design-system/lib/ProgressBar';
import { lengthFormatter, metersToMiles } from '../../new-order/estimate-path-time';
import { Tooltip, TooltipProps, tooltipClasses } from 'newmaterial-ui';
import { styled } from 'newmaterial-ui/styles';
import { GetUserAccess } from '../../../helper/module';

function removeNullFields(obj) {
  for (var key in obj) {
    if (obj[key] === null) {
      delete obj[key];
    } else if (typeof obj[key] === 'object') {
      removeNullFields(obj[key]);
    }
  }
  return obj;
}

function gtelteSetter(obj) {
  for (var key in obj) {
    if (["gte", "equal"].indexOf(key) > -1) {
      if (isObject(obj[key])) {
        obj[key] = momentJalaali(obj[key].day + "/" + obj[key].month + "/" + obj[key].year + " 00:01", "DD/MM/YYYY HH:mm").format("x")
      }
    } else if (["lte"].indexOf(key) > -1) {
      if (isObject(obj[key])) {
        obj[key] = momentJalaali(obj[key].day + "/" + obj[key].month + "/" + obj[key].year + " 23:59", "DD/MM/YYYY HH:mm").format("x")
      }
    } else if (typeof obj[key] === 'object') {
      gtelteSetter(obj[key]);
    }
  }
  return obj;
}



function StatusConverter(data , t) {
  let types = [];

  data.forEach(element => {
    types.push({
      id: element, title: t("EDAS_"+element)
    })
  });
  return types
}



    const HtmlTooltip = styled(({ className, ...props }) => (
        <Tooltip  {...props} classes={{ popper: className }} />
    ))(({ theme }) => ({
        [`& .${tooltipClasses.tooltip}`]: {
            backgroundColor: ' #fff',
            borderRadius: "8px",
            padding: "0",
            border: 'none',
            boxShadow: "0 4px 12px 0 rgba(0, 0, 0, 0.24)",
            color: 'rgba(0, 0, 0, 0.87)',
            maxWidth: 350,
            fontSize: theme.typography.pxToRem(12),
            marginBottom: "0px !important"
        },
            [`& .${tooltipClasses.arrow}`]: {
                color:"white"
            },
    }));


function RouteList() {
  const allFilters = useSelector((state) => state.Route.filters)

  const driverIdRoute = useSelector((state) => state.Route.filters.driverId)
  const status = useSelector((state) => state.Route.filters.status)
  const createdAt = useSelector((state) => state.Route.filters.createdAt)
  const name = useSelector((state) => state.Route.filters.name)
    const { t } = useTranslation();

  const dispatch = useDispatch();
  const [routesList, setRoutesList] = useState(null);
  const [loading, setLoading] = useState(false);
  let { createdAt_data, createdAt_OnChange } = GetRouteRangeFilter("createdAt")
  let { status_data, status_OnChange, status_list } = GetRouteCheckboxFilter("status", StatusConverter(['Unassigned', 'Assigned', 'Started', 'Done'] , t))
  const [DriverListloading, setDriverListloading] = useState(false);
  const [DriverList, setDriverList] = useState(null);
  const [ref, { height }] = useMeasure()
  const [showAddRoute, setShowAddRoute] = useState(false);
  const searchParams = useQuery();
  const driveridQuery = searchParams.get("driverid");
  const delayedQuerySP = React.useCallback(_.debounce((...pr) => getRoutesList(...pr), 800), []);
  const Globalsettings = useSelector((state) => state.SharedData.settings)


  useEffect(() => {
    if (driveridQuery && String(driveridQuery).length > 2) {
      getDriverInfo()
    }

    dispatch(ResetNewOrder())


  }, []);

  useEffect(() => {
    if (driveridQuery && String(driveridQuery).length > 2) {
      getDriverInfo()
    }

  }, [driveridQuery]);


  const getDriverInfo = useCallback(async (e) => {
    let Driver = new DriverApi()
    let driverData = await Driver.Info(driveridQuery)
    if (driverData.data) {
      dispatch(handleEditRouteFilter_Name({
        key: "driverId", value: {
          "id": driverData.data.id,
          "username": driverData.data.username,  
          "phone": driverData.data.phone,
          "name": driverData.data.name
        }
      }))


    }

  }, [driveridQuery]);



  const handleClose = () => {
    // dispatch(Table_setSelectedBulkEditStatusSummary(null))
  }

  // useEffect(() => {

  // }, [selectedBulkEditStatusSummary])

  useEffect(() => {
  try {
      document.addEventListener("routeUpdated", (e) => {
        console.log("addEventListener -> dispatcher:route:updated ", e);
  
        delayedQuerySP("routeUpdated")
      });
      return () => document.removeEventListener("routeUpdated", () => {
  
      });
  } catch (error) {
    
  }
  }, []);


  useEffect(() => {
  try {
      document.addEventListener("routeAdded", (e) => {
  
        delayedQuerySP("routeAdded")
  
  
      });
      return () => document.removeEventListener("routeAdded", () => {
  
      });
  } catch (error) {
    
  }
  }, []);


  useEffect(() => {
     getRoutesList("useEffect")
  }, [driverIdRoute, name, status, createdAt]);

  // useEffect(() => {
  //   (async () => {
  //     let Dispatcher = new DispatcherApi()
  //     let data = await Dispatcher.AutocompleteDriver()
  //   })();
  // }, []);

  const getRoutesList = useCallback(async (e) => {
    console.log("fregsvrsevreg ", e)
    let storeData = store.getState();
    const driverIdRoutex = storeData.Route.filters.driverId
    const statusx = storeData.Route.filters.status
    const createdAtx = storeData.Route.filters.createdAt
    const namex = storeData.Route.filters.name

    let params = JSON.parse(JSON.stringify({
      status: statusx,
      createdAt: createdAtx,
      name: (namex && String(namex).length > 0) ? namex : null,
      driverId: driverIdRoutex?.id
    }))
    setLoading(true)
    let Route = new RouteApi()
    let data = await Route.getRoutesList(gtelteSetter(removeNullFields(params)))
    setRoutesList(data)
    setLoading(false)

  }, [status , createdAt , name , driverIdRoute]);


  const searchDriverOnchange = useCallback(async (e) => {
    setDriverListloading(true)
    let Dispatcher = new DispatcherApi()
    let data = await Dispatcher.AutocompleteDriver({ searchRegex: e ? e : "" })
    setDriverList(data)
    setDriverListloading(false)

  }, []);

  const debouncedSearchDriver = useCallback(
    debounce(searchDriverOnchange, 500)
    , []);

  const driverHandle = useCallback((e) => {

    dispatch(handleEditRouteFilter_Name({ key: "driverId", value: e }))

  }, []);

  function handleAddRote(e, route) {
    setShowAddRoute(e)
  }

  useEffect(() => {
    try {
        if (showAddRoute) {
          const element = document.getElementById('googlemapUniqeId');
          element.style.zIndex = '6';
        } else {
          const element = document.getElementById('googlemapUniqeId');
          element.style.zIndex = '8';
        }
    } catch (error) {
      
    }
  
  
    }, [showAddRoute]);

      useEffect(() => {
    try {

          const element = document.getElementById('googlemapUniqeId');
          element.style.zIndex = '8';
        
    } catch (error) {
      
    }
  
  
    }, [ ]);
    
  const canClearAll = React.useCallback(() => {
    return !_.isEqual(defRoute.filters, allFilters)
  }, [allFilters]);

  const getStartDate = React.useCallback((route) => {
     let date = new Date(route.startDate);
    
    let options = { hour: '2-digit', minute: '2-digit' };
    let timeString = date.toLocaleTimeString([], options);
    let startTime;

//    console.log( route.name ,"fs0r-jbormfobjob ",date.toDateString() , now.toDateString() , new Date(now.setDate(now.getDate() + 1)).toDateString())
    
    // if (date.toDateString() == new Date().toDateString()) {
    //     startTime = `${t("Start time")}: ${t("Today")} ${jalali(route.startDate).locale(get_lang()).format("HH:mm")}`;
    // } else if (date.toDateString()  == new Date(new Date().setDate(new Date().getDate() - 1)).toDateString()) {
    //     startTime = `${t("Start time")}: ${t("Yesterday")} ${jalali(route.startDate).locale(get_lang()).format("HH:mm")}`;
    // } else if (date.toDateString()  == new Date(new Date().setDate(new Date().getDate() + 1)).toDateString()) {
    //     startTime = `${t("Start time")}: ${t("Tomorrow")} ${jalali(route.startDate).locale(get_lang()).format("HH:mm")}`;
    // } else {
    //     startTime = `${t("Start time")}: ${jalali(route.startDate).locale(get_lang()).format("D MMM HH:mm")}`;
    // }
    
   // return startTime

    return `${jalali(date).locale(get_lang()).format(checkTimestamp(date))}`;
    
    }, [ ]);


    const formatDurationAndDistance = React.useCallback((durationSeconds, distanceMeters) => {
  
      let distanceString = '';
      let durationString = '';
  
      // پردازش فاصله
      if (distanceMeters !== undefined && distanceMeters !== null) {
                  distanceString = String(lengthFormatter(Globalsettings.lengthUnit == "mile" ? metersToMiles(distanceMeters) : distanceMeters / 1000 , Globalsettings.lengthUnit , Globalsettings.lengthUnitFormat)).replace(/[\u00A0\s]+/g, '')
        
          // if (distanceMeters < 1000) {
          //     distanceString = `${distanceMeters}m`;
          // } else {
          //   let kilometers = (distanceMeters / 1000).toFixed(1);
          //    distanceString = `${parseInt(kilometers).toLocaleString()}km`;
          // }
      }
  
      // پردازش زمان
      if (durationSeconds !== undefined && durationSeconds !== null) {
          if (durationSeconds < 60) {
              durationString = `${durationSeconds}s`;
          } else if (durationSeconds < 3600) {
              let minutes = Math.floor(durationSeconds / 60);
              durationString = `${minutes}m`;
          } else {
              let hours = Math.floor(durationSeconds / 3600);
              let minutes = Math.floor((durationSeconds % 3600) / 60);
              if (minutes > 0) {
                durationString = `${hours}h , ${minutes}m`;
            } else {
                durationString = `${hours}h`;
            }
          }
      }
  
      // ترکیب نتایج
      if (distanceString && durationString) {
          return `${distanceString} | ${durationString}`;
      } else if (distanceString) {
          return distanceString;
      } else if (durationString) {
          return durationString;
      } else {
          return ''; // هیچ مقداری وجود ندارد
      }     }, [Globalsettings ]);
 

  const ClearAll = React.useCallback(() => {
    dispatch(clearAll_Route_ActiveFilter())
  }, []);


  // useEffect(() => {
  //   try {
  //       if (showAddRoute) {
  //         const element = document.getElementById('googlemapUniqeId');
  //         element.style.zIndex = '6';
  //       } else {
  //         const element = document.getElementById('googlemapUniqeId');
  //         element.style.zIndex = '7';
  //       }
  //   } catch (error) {
      
  //   }
  
  
  //   }, [showAddRoute]);

  return (
    <div className={styles.container}>
      {/* <RouteListNavbar /> */}

      

      <div className={styles.listMapContainer}>
        <div className={styles.listContainer}>
          <div className={styles.listfilters} ref={ref}>
            <DateFilter states={['Isbetween']} title={t('Date')} placement='bottomStart' value={createdAt_data} onChange={createdAt_OnChange} />
            <CheckBoxFilter title={t('status')} placement='bottomStart' list={status_list} value={status_data} onChange={status_OnChange} />

            <InputSerachFilter value={driverIdRoute} title={('Driver')} SearchList_ListItemChildren={DriverListItem} SearchList_error={false} SearchList_errorDescription={""} SearchList_errorIcon={null} SearchList_errorTitle={""}
              SearchList_inputIcon={null} SearchList_isloading={DriverListloading} SearchList_list={DriverList} SearchList_listItemOnclick={(e) => { }} SearchList_noResult={!DriverList || DriverList.length == 0}
              SearchList_noResultIcon={SEARCH_NOT_FOUND} SearchList_noResultTitle={t('No result found')} SearchList_onChange={(e) => { }} SearchList_placeHolder={"Search"} SearchList_ListItemOnClick={driverHandle} onChange={debouncedSearchDriver} SearchList_value={null} placement='bottomEnd'
            />
            {canClearAll() && <Typography onClick={ClearAll} weight='Body_Tiny_Bold' textColor='Primary' text={t('Clear All')} style={{ cursor: "pointer" }} />}
         {( routesList && loading) && <ProgressBar width={"100%"} style={{marginTop:"15px"}} />}
          </div>
          <div className={styles.listItemsContainer} style={{ height: `calc(100% - ${height}px)`, marginTop: `${height}px` }}>
            {(routesList && routesList.length > 0) && routesList?.map((route) => {
              return <Link to={`/route/${route.id}/0`}  > <div key={route?.id} id={route?.id} className={styles.routeItem}>
                <div className={clsx(styles.flag, styles[route.status])} />
                <div className={styles.twoRowsContainer}>
                  <div className={styles.firstRow}>
                    <Typography weight='Body_Middle_Medium' text={route.name} style={{ color: "#242424" ,flex:"1"}} />
                    {/* <span style={{ marginInlineStart: "auto", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "start", gap: "6px" }}>
                       <IconProvider Icon={box_gray} size='16' /> 
                       <Typography weight='Body_Small_Regular' text={String(route.stopCount)} style={{ color: "#242424" }} />
                       </span> */}
                 {(route.driver) && <HtmlTooltip arrow title={
                <div className={styles.popUpContainer}>
                    <div className={styles.popUpTitleDescContainer} style={{ padding:"8px"}}>
                  <Typography weight='Body_Small_Medium' text={<> {route.driver.name}  </>} style={{ color: "#242424" }} />

                    </div>
                 
                </div>
            } placement="top" onOpen={() => {   }} onClose={() => {  }} >
                <span className={styles.OrderStatusRowContainerInner}>
 <span style={{ marginInlineStart: "auto", display: "flex", flexDirection: "row", justifyContent: "center", alignItems: "start", gap: "6px" }}> <IconProvider Icon={DRIVER} /> <Typography weight='Body_Small_Regular' text={route.driver.username} style={{ color: "#242424" }} /></span> 
                    </span>
            </HtmlTooltip>}
                       <Tag icon={box_gray} style={{marginInlineStart: "auto"}} text={String(route.stopCount)} color='TextNormal' weight='Body_Small_Regular' iconSize='16' backgroundColor='GrayUltraLight' size='Medium' />
 
                  </div>

                  <div className={styles.secRow}>
                    <Typography weight='Body_Small_Regular' text={t("EDAS_"+route.status)} className={styles[route.status + 'span']} />
                    {(route.startDate && (route.status == "Unassigned" || route.status == "Assigned")) && <Tag icon={start_time}  style={{marginInlineStart: "6px"}}  text={getStartDate(route)} color='TextNormal' weight='Body_Small_Regular' iconSize='16' backgroundColor='GrayUltraLight' size='Medium' />}
                    {(route.distanceMeters || route.durationSeconds) ? <Tag icon={flag_gray}  style={{marginInlineStart: "6px"}}  text={formatDurationAndDistance(route.durationSeconds,route.distanceMeters)} color='TextNormal' weight='Body_Small_Regular' iconSize='16' backgroundColor='GrayUltraLight' size='Medium' /> : null}


                 
  
                  </div>
                </div>
              </div>
              </Link>
            })}

            
            {(!routesList && loading) && <ProgressIndicator theme='On_Light' className={styles.ProgressIndicator} />}
            {(routesList && !canClearAll() && routesList.length == 0 && !loading) && <NoRoutes reload={() => { setShowAddRoute(true) }} />}
            {(routesList && canClearAll() && routesList.length == 0 && !loading) && <NoRoutesFilters />}

          </div>
        </div>

  
      </div>
      {showAddRoute && <TableAddRoute onClose={handleAddRote} />}

    </div>
  )
}


export default RouteList



function NoRoutes({ reload, orderId, stop }) {
      const { t, i18n } = useTranslation();
  const [showAddRoute, setShowAddRoute] = useState(false);

        const dispatch = useDispatch();
        const center = useSelector((state) => state.Map.center)


        function handleAddRote(e, route) {
          setShowAddRoute(e)
        }
      

  return (
    <div className='jojojoj'
      style={{ display: 'flex', position: 'relative', height: `calc(100vh - 104px)`, width: "100%", flexDirection: 'column', transition: "all .3s ease-in-out", justifyContent: "center", alignItems: "center" }}>
      <div className={styles.dialog} style={{width:"100%"}}>
        {/* <IconProvider Icon={ROUTE_OPTIMIZE} style={{ marginBottom: "16px" }} />
        <Typography weight='Body_Middle_Bold' text='Add your routes' style={{ textAlign: "center", marginBottom: "4px" }} />
        <Typography weight='Body_Tiny_Regular' text='Your routes will be shown here in' style={{ textAlign: "center", marginBottom: "16px" }} />
        <Button size='Medium' type='Primary' text='Add Route' onClick={() => { reload(orderId, stop) }} />
      */}

      <RoutesListES articleTitle={"How to create route?"}
  articleLink={"https://help.onro.io/en/articles/10264436-how-to-create-a-new-route"}
  emptyStateTitle={(GetUserAccess().loaded && GetUserAccess().newRoute) && t("Add routes")}
  emptyStateDescription={(GetUserAccess().loaded && GetUserAccess().newRoute) &&t("Your routes will be shown here in")}
  LearnButton={<><LearnMore where='OndemandOrderList'  hastext={true} placement={"topStart"} /></>}
  NewButtonTitle={(GetUserAccess().loaded && GetUserAccess().newRoute) &&t("new")}
  onNewAction={()=>{
   (GetUserAccess().loaded && GetUserAccess().newRoute) && setShowAddRoute(true)
  }} />
      </div>
      {(showAddRoute &&  GetUserAccess().loaded && GetUserAccess().newRoute ) && <TableAddRoute onClose={handleAddRote} />}
    </div>
  )
}


function NoRoutesFilters() {
  const dispatch = useDispatch();



  const ClearAll = React.useCallback(() => {
    dispatch(clearAll_Route_ActiveFilter())
  }, []);
  return (
    <div className='jojojoj'
      style={{ display: 'flex', position: 'relative', height: `calc(100vh - 104px)`, width: "100%", flexDirection: 'column', transition: "all .3s ease-in-out", justifyContent: "center", alignItems: "center" }}>
      <div className={styles.dialog}>
        <IconProvider Icon={Routes_deactive} style={{ marginBottom: "16px" }} />
        <Typography weight='Body_Middle_Bold' text='No route found' style={{ textAlign: "center", marginBottom: "4px" }} />
        <Typography weight='Body_Tiny_Regular' text='Please check your filters or keyword' style={{ textAlign: "center", marginBottom: "16px" }} />
        <Button size='Medium' type='Primary' text='Clear All' onClick={ClearAll} />
      </div>
    </div>
  )
}



function RoutesError({ reload, orderId, stop }) {

  return (
    <div className='jojojoj'
      style={{ display: 'flex', position: 'relative', height: `calc(100vh - 104px)`, width: "100%", flexDirection: 'column', transition: "all .3s ease-in-out", justifyContent: "center", alignItems: "center" }}>
      <div className={styles.dialog}>
        <IconProvider Icon={Ic_danger} style={{ marginBottom: "16px" }} />
        <Typography weight='Body_Middle_Bold' text='Error in loading data' style={{ textAlign: "center", marginBottom: "4px" }} />
        <Typography weight='Body_Tiny_Regular' text='There was a problem loading data. please try again or contact support' style={{ textAlign: "center", marginBottom: "16px" }} />
        <Button size='Medium' type='Primary' text='Try again' onClick={() => { reload(orderId, stop) }} />
      </div>
    </div>
  )
}
